// Backend Service API calls
import axios from "axios";

let API_BASE_URL = import.meta.env.VITE_API_URL || "/api/v1";

// Main API client for backend services
export const apiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access

      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export const artisanAPI = {
  // Artisan API calls
  getArtisans: (params = {}) => {
    return apiClient.get("/artisans/", { params });
  },
  createArtisan: (artisanData) => {
    return apiClient.post("/artisans/", artisanData);
  },
  deleteArtisan: (id) => {
    return apiClient.delete(`/artisans/${id}`);
  },
  updateArtisan: (id, artisanData) => {
    return apiClient.put(`/artisans/${id}`, artisanData);
  },
  readArtisan: (id) => {
    return apiClient.get(`/artisans/${id}`);
  },
  importArtisansFromXlsx: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post("/artisans/import/xlsx", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
